(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var menuButton = document.querySelector('.mobile-menu-button');
    var mobileMenu = document.getElementById('MobileMenu');
    if (menuButton && mobileMenu) {
      menuButton.addEventListener('click', function () {
        var open = menuButton.getAttribute('aria-expanded') === 'true';
        menuButton.setAttribute('aria-expanded', String(!open));
        mobileMenu.hidden = open;
      });
    }

    document.querySelectorAll('[data-variant-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var option = select.options[select.selectedIndex];
        var root = select.closest('[data-product-root]');
        var price = root && root.querySelector('[data-product-price]');
        if (price && option.dataset.price) price.textContent = option.dataset.price;
      });
    });
  });
})();
